import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import Muse from "./Muse/Muse.js";
import ElectrodeMuse from "./Muse/ElectrodeMuse.js";

import './museConnector.css';
function MuseConnector(props) {

    const [isConnected, setConnected] = useState(false);
    let myColor = props.color;
    let af7sensor = new ElectrodeMuse("af7sensor");
    let af8sensor = new ElectrodeMuse("af8sensor");
    let tp9sensor = new ElectrodeMuse("tp9sensor");
    let tp10sensor = new ElectrodeMuse("tp10sensor");
    let bandeauMuse = new Muse('0000fe8d-0000-1000-8000-00805f9b34fb', '273e0003-4c4d-454d-96be-f03bac821358', '273e0004-4c4d-454d-96be-f03bac821358', '273e0005-4c4d-454d-96be-f03bac821358', '273e0006-4c4d-454d-96be-f03bac821358', af7sensor, af8sensor, tp9sensor, tp10sensor);

    async function handleClick() {
        if(!isConnected)
        {
            let connected = await bandeauMuse.connexion();
            if(connected)
            {
                setConnected(true);
                props.handleMuseConnected(bandeauMuse);
            }
        }else{
            bandeauMuse = new Muse('0000fe8d-0000-1000-8000-00805f9b34fb', '273e0003-4c4d-454d-96be-f03bac821358', '273e0004-4c4d-454d-96be-f03bac821358', '273e0005-4c4d-454d-96be-f03bac821358', '273e0006-4c4d-454d-96be-f03bac821358', af7sensor, af8sensor, tp9sensor, tp10sensor);
            setConnected(false);
            props.handleMuseDisconnected();
        }
    }

    return(
        <Button variant="outlined" color={myColor} onClick={handleClick}>{isConnected ? "CONNECTED" : "CONNECT"}</Button>
    )
}

export default MuseConnector;